import { StandardButton } from "../../atoms/buttons";
import { Spinner } from "../../atoms/spinner";
import { icon } from "../../functions/icons";
import { VerticalLayout } from "../layout";
import TapToLearn from "../tap-to-learn/TapToLearn";
import AssessmentFinished from "./AssessmentFinished";
import AssessmentPage from "./AssessmentPage";
import AssessmentStart from "./AssessmentStart";

export default function HandleAssessment({
  embedPage,
  finished,
  elearningInformation,
  embedBtnState,
  startEmbedAssessment,
  triggerConfetti,
  id,
  embedStructure,
  currentAssessment,
  setEmbedStructure,
  setCurrentAssessment,
  setFinished,
  quizStructure,
  setQuizStructure,
  setMaxReachedModule,
  maxReachedModule,
}) {
  switch (embedPage) {
    case "loading":
      return (
        <VerticalLayout>
          <Spinner color="grey-100" size="4rem" />
        </VerticalLayout>
      );

    case "not_found":
      return (
        <EmbedError
          iconType="link-off"
          errorTitle="Ongeldige embed"
          message="Controleer de URL die u probeert te embedden of neem contact op met de beheerder."
        />
      );

    case "start":
      return (
        <AssessmentStart
          elearningInformation={elearningInformation}
          embedBtnState={embedBtnState}
          startEmbedAssessment={startEmbedAssessment}
        />
      );

    case "assessment":
      return finished ? (
        <AssessmentFinished
          elearningInformation={elearningInformation}
          triggerConfetti={triggerConfetti}
          id={id}
        />
      ) : (
        <AssessmentPage
          elearningInformation={elearningInformation}
          embedStructure={embedStructure}
          currentAssessment={currentAssessment}
          setEmbedStructure={setEmbedStructure}
          setCurrentAssessment={setCurrentAssessment}
          setFinished={setFinished}
          quizStructure={quizStructure}
          setQuizStructure={setQuizStructure}
          setMaxReachedModule={setMaxReachedModule}
          maxReachedModule={maxReachedModule}
          id={id}
        />
      );
    case "tap-to-learn":
      return <TapToLearn />;
    default:
      return null;
  }
}

const EmbedError = ({ iconType, errorTitle, message }) => (
  <VerticalLayout className="center-all complete-height embed-error-box">
    <span
      className="small-standard-margin"
      style={{ color: "var(--grey-500)" }}
    >
      {icon(iconType, 96)}
    </span>
    <span
      style={{
        color: "var(--grey-300)",
        textAlign: "center",
        fontSize: "1.5rem",
        fontWeight: 600,
        margin: "0.5rem 0px",
      }}
    >
      {errorTitle}
    </span>
    {message && (
      <span
        style={{
          color: "var(--grey-500)",
          textAlign: "center",
          margin: "0px 2rem",
          fontSize: "14px",
        }}
      >
        {message}
      </span>
    )}
    <StandardButton
      onClick={() => window.open("https://expligo.nl/", "_blank")?.focus()}
      style={{ background: "#374e68", marginTop: "3rem" }}
      size="large"
    >
      Ontdek Expligo{" "}
      <span style={{ marginLeft: "0.5rem" }}>{icon("open-url")}</span>
    </StandardButton>
  </VerticalLayout>
);
